import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SmileySad } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-brand-bg flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-lg w-full rounded-3xl border border-brand-line bg-brand-surface p-10 text-center"
        data-testid="payment-cancel-page"
      >
        <SmileySad size={60} weight="thin" className="text-brand-gold mx-auto" />
        <h1 className="font-serif text-4xl text-brand-text mt-6">Checkout cancelled</h1>
        <p className="text-brand-dim mt-3">
          No charge was made. Your ebook is still waiting whenever you're ready.
        </p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="cancel-back-home"
            className="rounded-full bg-brand-text px-8 py-4 text-sm font-medium text-brand-bg hover:bg-brand-gold transition-colors"
          >
            Back to the library
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
